module.exports = __webpack_public_path__ + "img/shirt-black.5416066.svg";